import { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import { useGetAllStatesQuery } from "../../states/statesApi";
import SelectField from "../../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import { useGetCollectorByIdQuery, useUpdateCollectorMutation } from "../collector";
import { useParams } from "react-router-dom";
import { FaLink, FaSearch, FaTimes } from "react-icons/fa";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import IconButton from "../../../../components/common/form/IconButton";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import { useSearchScraperModulesQuery } from "../../../tenantAdmin/scraperModule/scraperModuleApi";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useSearchTaxRoundingConfigQuery } from "../../taxRoundingConfig/taxRoundingConfigApi";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { useLazyGetAllCountyByStateIdQuery } from "../../counties/countiesApi";
import { tgxApi } from "../../../../app/tgxApi";
import { useDispatch } from "react-redux";


interface Props {
    isReadOnly?: boolean
}


const CollectorDetailInfo: FC<Props> = ({ isReadOnly = false }) => {
    let { collectorId } = useParams();
    const dispatch = useDispatch();
    const [collectorsData, setCollectorsData] = useState<any>({});
    const collectorData = useGetCollectorByIdQuery(collectorId);
    const statesApiResult = useGetAllStatesQuery("");
    const [countyIdApiResultApi, countyIdApiResult] = useLazyGetAllCountyByStateIdQuery();
    const [showButtons, setShowButtons] = useState<boolean>(false);
    const [updateCollectorApi, updateCollectorApiResponse] = useUpdateCollectorMutation()
    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const [showModuleNameModal, setShowModuleNameModal] = useState<boolean>(false);
    const [showRoundigConfigModal, setShowRoundigConfigModal] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<any>({});

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        setCollectorsData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
        setShowButtons(true);
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {
            collectorId: collectorId,
            state: {
                id: collectorsData.state.value
            },
            countyId: collectorsData?.countyId?.value ?? null,

            scraperModuleId: collectorsData?.moduleName
                ? collectorsData.moduleName.id
                : null,

            taxRoundingConfigurationId: collectorsData?.taxRounding
                ? collectorsData.taxRounding.id
                : null,
            dataImportsEnabled: collectorsData?.dataImportsEnabled,
            billsReleased : collectorsData?.billsReleased,

            isPrimaryCollector: collectorsData?.isPrimaryCollector,
            taxSuitCollector: collectorsData?.taxSuitCollector,
            name: collectorsData?.name,
            payableTo: collectorsData?.payableTo
        }
        const UpdateSystemProperty = async () => {
            await updateCollectorApi({
                id: collectorId,
                requestBody: obj,
            }).unwrap();
        };
        await handleRTKQuery(UpdateSystemProperty, () => {
            setShowButtons(false);
        });
    }


    const handleClearField = (fieldName: string) => {
        setCollectorsData((prevData: any) => {
            return {
                ...prevData,
                [fieldName]: '',
            };
        });
    };

    useEffect(() => {
        if (collectorData?.data) {
            const obj = collectorData?.data;

            const intialCollectorData: any = {
                ...obj,
                state: {
                    label: obj?.state?.stateName,
                    value: obj?.state?.id,
                },

                moduleName: obj?.scraperModule,
                taxRounding: obj?.taxRoundingConfiguration
            }
            if (countyIdApiResult?.data) {
                const matchedCounty = countyIdApiResult.data.find(
                    (item: any) => item?.id?.toLowerCase() === obj?.countyId?.toLowerCase()
                );

                intialCollectorData.countyId = matchedCounty
                    ? {
                        label: matchedCounty.countyName,
                        value: matchedCounty.id,
                    }
                    : {
                        value: obj?.countyId,
                    };
            } else {
                countyIdApiResultApi(obj?.state?.id);
                if (obj.countyId) {
                    intialCollectorData.countyId = {
                        value: obj?.countyId,
                    };
                }
                else {
                    intialCollectorData.countyId = null
                }

            }
            setCollectorsData(intialCollectorData);
        }
    }, [collectorData]);

    useEffect(() => {

        if (collectorsData) {
            if (countyIdApiResult?.data && collectorsData?.state && collectorsData?.countyId) {
                const matchedCounty = countyIdApiResult?.data?.find(
                    (item: any) => item?.id?.toLowerCase() === collectorsData?.countyId?.value?.toLowerCase()
                );

                setCollectorsData({
                    ...collectorsData,
                    countyId: {
                        label: matchedCounty?.countyName,
                        value: matchedCounty?.id
                    },
                })
            } else if (!collectorsData?.countyId) {
                setCollectorsData({
                    ...collectorsData,
                    countyId: null,
                });
            }
        }
    }, [countyIdApiResult?.data]);

    const handCancel = async (e?: React.MouseEvent<HTMLButtonElement>) => {
        e?.preventDefault();
        setShowButtons(false);
        dispatch(tgxApi.util.invalidateTags([
            "collectorById"
        ]));
    };

    const handleOnClick = (e: any, name: string) => {
        e.preventDefault();
        setCollectorsData({
            ...collectorsData,
            [name]: selectedRow
        })
        setShowButtons(true)
        setShowModuleNameModal(false)
        setShowRoundigConfigModal(false)
    }

    const moduleNameColumns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },
        {
            label: "Module Key",
            accessor: "moduleKey",
        }
    ]

    const taxConfigNameColumns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },

    ]

    const handleToggle = (property: string) => () => {
        setCollectorsData((prevData: any) => {
            const toggledValue = !prevData[property];

            return {
                ...prevData,
                [property]: toggledValue,
                ...(property === "isPrimaryCollector" && prevData[property] === true
                    ? { countyId: null }
                    : {})
            };
        });

        setShowButtons(true);
    };
    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md">
            <Form
                onSubmit={handleSubmit}
                fields={
                    <>
                        <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                            <h1
                                className={collectorsData?.deleted === true ? "text-[red]" : ""}
                            >
                                {collectorsData?.deleted === false
                                    ? "Collector Details"
                                    : "Collector Details (Deleted Record)"}
                            </h1>
                            {showButtons && !isReadOnly && (
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => handCancel(),
                                                type: "close",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Submit",
                                                type: "submit",
                                                isLoading: (updateCollectorApiResponse.isLoading),
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align="end"
                                    gap={2}
                                />
                            )}
                        </div>
                        <div className={'p-2'}>
                            <InputField name="name"
                                label="Name" value={collectorsData?.name || ""}
                                onChange={handleOnChange}
                                required
                                placeholder="Enter Name..."
                                disabled={isReadOnly} />

                            <InputField
                                name="payableTo"
                                label="Payable To"
                                value={collectorsData?.payableTo || ""}
                                onChange={handleOnChange}
                                placeholder="Enter Payable To..."
                                disabled={isReadOnly} />



                            <InputField
                                name="moduleName"
                                label="Module Name"
                                onChange={handleOnChange}
                                value={collectorsData?.moduleName?.name || ""}
                                type="text"
                                placeholder="Enter Module Name..."
                                disabled={isReadOnly}
                                icon={<IconButton
                                    icon={<FaLink onClick={() => {
                                        if (collectorsData?.moduleName?.id) {
                                            window.open(`/scrapers-modules/${collectorsData?.moduleName?.id}`, '_blank');
                                        } else {
                                            window.open(`/scrapers-modules`, '_blank');
                                        }

                                    }} />
                                    }
                                    className={`text-sm ${collectorsData?.moduleName ? 'text-highlight-4' : 'text-surface-4 cursor-default'
                                        }`}
                                    title={"Create Module Namey"}
                                />}
                                onClick={() => setShowModuleNameModal(true)}
                                className="cursor-pointer"
                                inputIcon={
                                    collectorsData?.moduleName ? (
                                        <FaTimes
                                            className={iconButtonStyle}
                                            title="Clear Module Name"
                                            onClick={() => handleClearField("moduleName")}
                                        />
                                    ) : (
                                        <FaSearch
                                            className={iconButtonStyle}
                                            title="Add Module Name"
                                            onClick={() => setShowModuleNameModal(true)}
                                        />
                                    )

                                }
                            />
                            <SelectField
                                placeholder='Select State...'
                                value={collectorsData?.state}
                                options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "state", value: selectedOption })
                                }}
                                label={"State"}
                                required
                                isDisabled={isReadOnly}
                            />


                            {collectorsData?.isPrimaryCollector && (
                                <SelectField
                                    placeholder='Select County...'
                                    value={collectorsData?.countyId}
                                    options={createOptionListForSelectTag(countyIdApiResult?.data, "countyName", "id")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "countyId", value: selectedOption })
                                    }}
                                    label={"County"}
                                    required
                                    isDisabled={isReadOnly}
                                />
                            )}

                            <InputField
                                name="primaryCollector"
                                label="Primary Collector"
                                type="checkbox"
                                checked={collectorsData?.isPrimaryCollector}
                                onChange={handleToggle("isPrimaryCollector")}
                                disabled={isReadOnly}
                            />



                            <InputField
                                name="taxRounding"
                                label="Tax Rounding Config"
                                onChange={handleOnChange}
                                value={collectorsData?.taxRounding?.name || ""}
                                type="text"
                                placeholder="Enter Tax Rounding Config..."
                                onClick={() => setShowRoundigConfigModal(true)}
                                className="cursor-pointer"
                                disabled={isReadOnly}
                                icon={<IconButton
                                    icon={<FaLink onClick={() => {
                                        if (collectorsData?.taxRounding?.id) {
                                            window.open(`/tax-rounding-config/${collectorsData?.taxRounding?.id}`, '_blank');
                                        } else {
                                            window.open(`/tax-rounding-config`, '_blank');
                                        }

                                    }} />
                                    }
                                    className={`text-sm ${collectorsData?.taxRounding ? 'text-highlight-4' : 'text-surface-4 cursor-default'
                                        }`}
                                    title={"Create Tax Rounding Config"}
                                />}
                                inputIcon={
                                    collectorsData?.taxRounding ? (
                                        <FaTimes
                                            className={iconButtonStyle}
                                            title="Clear Tax Rounding Config"
                                            onClick={() => {
                                                handleClearField("taxRounding")
                                                setShowButtons(true);
                                            }}
                                        />
                                    ) : (
                                        <FaSearch
                                            className={iconButtonStyle}
                                            title="Add Tax Rounding Config"
                                            onClick={() => setShowRoundigConfigModal(true)}
                                        />
                                    )

                                }
                            />



                            <InputField
                                name="taxSuitCollector"
                                label="Tax Suit Collector"
                                type="checkbox"
                                checked={collectorsData?.taxSuitCollector}
                                onChange={handleToggle("taxSuitCollector")}
                                className="mt-7"
                                disabled={isReadOnly}
                            />
                            <InputField
                                name="dataImportsEnabled"
                                label="Data Imports Enabled"
                                type="checkbox"
                                checked={collectorsData?.dataImportsEnabled}
                                onChange={handleToggle("dataImportsEnabled")} disabled={isReadOnly} />

                            <InputField
                                name="billsReleased"
                                label="Bills Released"
                                type="checkbox"
                                checked={collectorsData?.billsReleased}
                                onChange={handleToggle("billsReleased")} disabled={isReadOnly} />
                        </div>

                    </>
                }
            />
            {showModuleNameModal &&
                <CommonSelectorModal
                    title="Module Name Selector"
                    columns={moduleNameColumns}
                    data={useSearchScraperModulesQuery}
                    show={showModuleNameModal}
                    onSubmit={(e: any) => handleOnClick(e, "moduleName")}
                    setShow={setShowModuleNameModal}
                    setSelectedRow={setSelectedRow}
                />
            }
            {showRoundigConfigModal &&
                <CommonSelectorModal
                    title="Tax Rounding Config Selector"
                    columns={taxConfigNameColumns}
                    data={useSearchTaxRoundingConfigQuery}
                    show={showRoundigConfigModal}
                    onSubmit={(e: any) => handleOnClick(e, "taxRounding")}
                    setShow={setShowRoundigConfigModal}
                    setSelectedRow={setSelectedRow}
                />
            }
        </div>
    );
};

export default CollectorDetailInfo;
